var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{on:{"page:beforein":_vm.beforein}},[_c('navbar',{attrs:{"text":`${_vm.$t('Configuration.name')} > ${_vm.$t('Configuration.Tasks_Title')}`}}),_vm._v(" "),_c('TasksDatabase',{attrs:{"task-definitions":_vm.taskDefinitions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }